import {Component, EventEmitter, Input, Output} from '@angular/core';

/**
 * Component for the content navbar header
 * @class ContentHeaderComponent
 */
@Component({
  selector: 'advtech-content-header',
  templateUrl: './content-header.component.html',
})
export class ContentHeaderComponent {
  /**
   * Input for the title of the header
   */
  @Input()
  title: string;

  /**
   * EventEmitter for the hamburger click
   * @type {EventEmitter}
   */
  @Output()
  onHamburgerToggle: EventEmitter<Event> = new EventEmitter();

  /**
   * Fires the onHamburgerToggle event
   *
   * @param {Event} e the window event
   * @returns {void}
   */
  hamburgerToggle(e: Event) {
    this.onHamburgerToggle.emit(e);
  }
}


// WEBPACK FOOTER //
// ./src/app/content/shared/components/content-header/content-header.component.ts